import z from 'zod';

import { productEntityFields } from './product-fields';

export const cart = {
  cartId: z.string(),
  products: z.array(z.object({ ...productEntityFields })).nonempty(),
};

export default {
  viewed: z.object({
    ...cart,
  }),
};
